// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__23hZo","alertIcon":"ConfirmModal_alertIcon__IYNuM"};